module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-1200.05c0dffe.svg";